import React from "react";
import Button from "components/UI/Button";
import Input from "components/UI/Input";
import "./style.css";
import axios from "axios";
import { API_URL, ERROR_HANDLE } from "config/constants";
class ForgotPasswordScreen extends React.Component {
  state = {
    email: ""
  };
  resetPassword = email => {
    axios
      .get(`${API_URL}/admin/send_password_reset_link/${email}`)
      .then(res => {
        console.log(res);
      })
      .catch(err => {
        ERROR_HANDLE(err);
        this.setState({ email: "" });
      });
  };
  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.resetPassword(this.state.email);
    }
  };
  render() {
    const { email } = this.state;
    return (
      <div className="div_ForgotPasswordScreen">
        <h3
          style={{
            fontSize: "22.5px",
            fontWeight: "normal",
            fontStyle: "normal",
            fontStretch: "normal",
            letterSpacing: "2.3px",
            textAlign: "center",
            color: "var(--secondary)"
          }}
        >
          Forgot Password?
        </h3>
        <h4
          style={{
            fontSize: "12.5px",
            fontWeight: "normal",
            fontStyle: "normal",
            fontStretch: "normal",
            letterSpacing: "0.7px",
            textAlign: "center",
            color: "var(--secondary)"
          }}
        >
          We'll send a password reset link to your mail
        </h4>
        <Input
          type="text"
          placeholder="Email"
          value={email}
          onChange={e => {
            this.setState({ email: e.target.value });
          }}
          onKeyPress={this.handleKeyPress}
        />
        <br />
        <br />
        <Button
          type="primary"
          rectangle
          onClick={() => {
            this.resetPassword(this.state.email);
          }}
        >
          <span
            style={{
              lineHeight: 2.17,
              letterSpacing: "5.5px",
              textAlign: "center"
            }}
          >
            SEND EMAIL
          </span>
        </Button>
      </div>
    );
  }
}

export default ForgotPasswordScreen;
